import { render, staticRenderFns } from "./slideBarItem.vue?vue&type=template&id=63a20f71&"
import script from "./slideBarItem.vue?vue&type=script&lang=js&"
export * from "./slideBarItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports